import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import { LOGO_URL } from "@/lib/brand";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A3B4D] text-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img
              src={LOGO_URL}
              alt="AMAC Family Apartments & Suites"
              className="h-24 w-auto mb-5 block"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="text-[#FAF9F6]/70 leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-overline text-[#FAF9F6]/60 mb-4">
              {t.footer.contact}
            </p>
            <a
              data-testid="footer-email"
              href="mailto:booking@amacsuites.com"
              className="block text-[#FAF9F6] hover:text-white underline-offset-4 hover:underline"
            >
              booking@amacsuites.com
            </a>
            <a
              data-testid="footer-phone"
              href="tel:+393793581538"
              className="block text-[#FAF9F6] hover:text-white underline-offset-4 hover:underline mt-1"
            >
              +39 379 358 15 38
            </a>
            <p className="text-[#FAF9F6]/70 mt-3 text-sm leading-relaxed">
              {t.footer.address}
            </p>
            <div className="mt-5 text-xs text-[#FAF9F6]/55 leading-relaxed space-y-0.5">
              <p data-testid="footer-cir">CIR: 009034-LT-2290</p>
              <p data-testid="footer-cin">CIN: IT009034C2RE3RHHK7</p>
            </div>
          </div>
          <div className="md:text-right space-y-3">
            <Link
              data-testid="footer-about-link"
              to="/about"
              className="block text-[#FAF9F6]/80 hover:text-white underline-offset-4 hover:underline text-sm"
            >
              {t.nav.about}
            </Link>
            <a
              data-testid="footer-book-btn"
              href="/#booking"
              className="inline-flex items-center px-6 py-3 rounded-full bg-[#FAF9F6] text-[#1A3B4D] text-sm tracking-wide hover:bg-white transition-colors"
            >
              {t.nav.book} →
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FAF9F6]/15 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#FAF9F6]/60">
          <p>© {new Date().getFullYear()} AMAC Family Apartments & Suites · {t.footer.rights}</p>
          <p>Via Donizetti 9 · 17025 Loano (SV)</p>
        </div>
      </div>
    </footer>
  );
}
